/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchPccDemographicsResponse } from './PatchPccDemographicsResponse';
import {
    PatchPccDemographicsResponseFromJSON,
    PatchPccDemographicsResponseFromJSONTyped,
    PatchPccDemographicsResponseToJSON,
    PatchPccDemographicsResponseToJSONTyped,
} from './PatchPccDemographicsResponse';

/**
 * 
 * @export
 * @interface PatchPccDemographics200Response
 */
export interface PatchPccDemographics200Response {
    /**
     * 
     */
    data?: PatchPccDemographicsResponse;
}

/**
 * Check if a given object implements the PatchPccDemographics200Response interface.
 */
export function instanceOfPatchPccDemographics200Response(value: object): value is PatchPccDemographics200Response {
    return true;
}

export function PatchPccDemographics200ResponseFromJSON(json: any): PatchPccDemographics200Response {
    return PatchPccDemographics200ResponseFromJSONTyped(json, false);
}

export function PatchPccDemographics200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchPccDemographics200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PatchPccDemographicsResponseFromJSON(json['data']),
    };
}

export function PatchPccDemographics200ResponseToJSON(json: any): PatchPccDemographics200Response {
    return PatchPccDemographics200ResponseToJSONTyped(json, false);
}

export function PatchPccDemographics200ResponseToJSONTyped(value?: PatchPccDemographics200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PatchPccDemographicsResponseToJSON(value['data']),
    };
}

